import ExternalLink from './components/shared/ExternalLink';

import './Disclosure.css'

export const Disclosure = () => {
    return <>
        {
            <div className='footer-container'>
                Vehicle Diagnostic AI can make mistakes. Please consult a qualified technician before making repairs.
                <div className='footer-link-row'>
                    <ExternalLink title="Privacy Policy" url="https://www.innova.com/pages/privacy-policy?ad=aaa" />
                    <ExternalLink title="Terms of Use" url="https://www.innova.com/pages/terms-of-use?ad=aaa" />
                </div>
            </div>
        }
    </>
}

